import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ControlsSkipNextFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M15.86 11.96L4.94 18.76V5.16L15.86 11.96ZM20.28 18.6H17.12V5.32H20.28V18.6Z" />
    </SvgIcon>
  );
});
